import { composeSpawn } from './spawnComposition.js';

export function alertNearbyEnemies(game, sourceX, sourceZ, radius = 8.5) {
  const player = game.player;
  if (!player?.alive) return;
  const r2 = radius * radius;
  for (const e of game.enemies) {
    if (!e.alive) continue;
    const dx = e.x - sourceX;
    const dz = e.z - sourceZ;
    if (dx * dx + dz * dz <= r2) {
      e.notifyPlayerDetected?.(player.x, player.z, 2.8);
    }
  }
}

export function composeSpawnForRoom(game, roomNum, variantId = null) {
  return composeSpawn({
    roomNum,
    variantId,
    rng: game.rng,
  });
}

export function pauseGame(game) {
  if (game.state === 'playing') {
    game.state = 'paused';
    game.hud.hideDropTooltip();
    game.hud.setDimmed?.(true);
    game.menuCtl.showPause();
  }
}

export function resumeGame(game) {
  if (game.state === 'paused') {
    game.state = 'playing';
    game.hud.setDimmed?.(false);
    game.menuCtl.hidePause();
  }
}

export function quitRun(game, totalRooms) {
  game.spawnRuntime?.stop();
  game._clearEnemiesAndProjectiles();
  game._clearShards();
  game._clearAmmoPickups();
  game._clearWeaponPickups();
  game._clearGroundWeaponPickups();
  game._clearLootPickups();
  game._clearPlayerMines();
  game.slashFx.clear();
  if (game.room) { game.room.dispose(); game.room = null; }
  game.state = 'menu';
  game.runMode = 'run';
  game.totalRooms = totalRooms;
  game._sandboxGodMode = false;
  if (game.player) {
    game.player.invuln = 0;
    game.player.setDebugHidden(false);
  }
  game._setSandboxDebugPanelVisible(false);
  game.hud.hide();
  game.hud.setDimmed?.(false);
  game.hud.hideDropTooltip();
  game.menuCtl.showMenu();
  game.audio.playMusic('menu');
  game._updateFogOfWar();
}


